/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_ConnectedInputs */

const cs_settings_calendar_connected = /** @type {(inputs: Settings_Calendar_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojeno`)
};

const en_settings_calendar_connected = /** @type {(inputs: Settings_Calendar_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Settings_Calendar_ConnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_connected = /** @type {((inputs?: Settings_Calendar_ConnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_ConnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_connected(inputs)
	return cs_settings_calendar_connected(inputs)
});